import { EventSingle } from './event';

export const GET_PASS_SUBSCRIPTION = 'GET_PASS_SUBSCRIPTION';
export const GET_PASS_SUBSCRIPTION_SUCCESS = 'GET_PASS_SUBSCRIPTION_SUCCESS';
export const GET_PASS_SUBSCRIPTION_ERROR = 'GET_PASS_SUBSCRIPTION_ERROR';

export const ADD_PASS_SUBSCRIPTION = 'ADD_PASS_SUBSCRIPTION';
export const ADD_PASS_SUBSCRIPTION_SUCCESS = 'ADD_PASS_SUBSCRIPTION_SUCCESS';
export const ADD_PASS_SUBSCRIPTION_ERROR = 'ADD_PASS_SUBSCRIPTION_ERROR';

export const CANCEL_PASS_SUBSCRIPTION = 'CANCEL_PASS_SUBSCRIPTION';
export const CANCEL_PASS_SUBSCRIPTION_SUCCESS = 'CANCEL_PASS_SUBSCRIPTION_SUCCESS';
export const CANCEL_PASS_SUBSCRIPTION_ERROR = 'CANCEL_PASS_SUBSCRIPTION_ERROR';

export interface PassSubscriptionRequest {
    userId: string;
    salesChannelId: number;
}

export interface passIdWithQuantity {
    passId: number;
    quantity: number;
}

export interface AddPassSubscriptionRequest {
    userId: string;
    passesToSubscribe: passIdWithQuantity[];
    salesChannelId: number;
}

export interface CancelPassSubscriptionRequest {
    passId: number;
    userId: string;
    salesChannelId: number;
}

export interface PassSubscriptionSingle {
    id: number;
    user_id: number;
    pass_id: number;
    quantity: number;
    subscription_id: string;
    subscribed: boolean;
    start_date: Date;
    end_date: Date;
    created: Date;
    updated: Date;
    cancelled_at: Date | null;
    pass_setting: {
        id: number;
        title: string;
        description: string;
        amount: string;
        currency: string;
        start_date: Date;
        end_date: Date;
        is_enabled: number;
        pass_events: Array<{
            id: number;
            pass_id: number;
            event_id: number;
            event: EventSingle[];
        }>;
    };
    pass_events: EventSingle[];
    expiry_date: Date | null;
    renewal_date: Date | null;
    days_left: number;
    timezone: string;
    eligible_for_refund: boolean;
    is_pass_active: boolean;
}

export interface CancelPassSubscriptionSuccessResponse {
    message: string;
}

export interface CancelPassSubscriptionSuccess {
    passId: number;
    isCancelled: boolean;
}

export interface PassSubscriptionError {
    body?: {
        message?: string;
        status?: string;
    };
    message?: string;
    name?: string;
    status?: number;
}

export interface PassSubscriptionState {
    data: Array<PassSubscriptionSingle> | null;
    loading: boolean;
    error: PassSubscriptionError | null;
    isCancelLoading: boolean;
    cancelError: PassSubscriptionError | null;
}

export interface GetPassSubscriptionAction {
    type: typeof GET_PASS_SUBSCRIPTION;
}

export interface GetPassSubscriptionSuccessAction {
    type: typeof GET_PASS_SUBSCRIPTION_SUCCESS;
    payload: Array<PassSubscriptionSingle>;
}

export interface GetPassSubscriptionErrorAction {
    type: typeof GET_PASS_SUBSCRIPTION_ERROR;
    payload: PassSubscriptionError | null;
}

export interface AddPassSubscriptionAction {
    type: typeof ADD_PASS_SUBSCRIPTION;
}

export interface AddPassSubscriptionSuccessAction {
    type: typeof ADD_PASS_SUBSCRIPTION_SUCCESS;
    payload: Array<PassSubscriptionSingle>;
}

export interface AddPassSubscriptionErrorAction {
    type: typeof ADD_PASS_SUBSCRIPTION_ERROR;
    payload: PassSubscriptionError;
}
export interface CancelPassSubscriptionAction {
    type: typeof CANCEL_PASS_SUBSCRIPTION;
}

export interface CancelPassSubscriptionSuccessAction {
    type: typeof CANCEL_PASS_SUBSCRIPTION_SUCCESS;
    payload: CancelPassSubscriptionSuccess;
}

export interface CancelPassSubscriptionErrorAction {
    type: typeof CANCEL_PASS_SUBSCRIPTION_ERROR;
    payload: PassSubscriptionError;
}

export type PassSubscriptionAction =
    | GetPassSubscriptionAction
    | GetPassSubscriptionSuccessAction
    | GetPassSubscriptionErrorAction
    | AddPassSubscriptionAction
    | AddPassSubscriptionSuccessAction
    | AddPassSubscriptionErrorAction
    | CancelPassSubscriptionAction
    | CancelPassSubscriptionSuccessAction
    | CancelPassSubscriptionErrorAction;
